import { queryClient } from '../clients/queryClient';
import { liveResultCache } from './liveResultCache';

/**
 * Clear every in-memory cache that could survive a logout. Deleting the Dexie DB
 * is not enough on a shared device: the React Query cache (staleTime 10min /
 * gcTime 30min) returns the PREVIOUS user's inspections synchronously on the
 * next login's warm mounts, and the liveResultCache seeds Welcome/History with
 * their cards. Call this wherever the app signs out.
 */
export function clearSessionCaches(): void {
  queryClient.clear();
  liveResultCache.clear();
}
